<template>
  <Drawer width="400" v-model="drawerOpened" :title="'新增技术服务工单'">
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="客户" prop="customer" style="width: 366px">
          <Select
            v-model="formItem.customer"
            filterable
            remote
            style="width: 350px"
            :remote-method="searchCustomer"
            :loading="customerLoading"
            placeholder="请填写客户名字后选择"
          >
            <Option
              v-for="option in customerList"
              :value="option._id"
              :key="option._id"
              style="width: 350px"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <div class="dateTime">
          <FormItem
            label="日期"
            prop="date"
            style="width: 150px; margin-right: 50px"
          >
            <DatePicker
              v-model="formItem.date"
              type="date"
              @on-change="chooseDate"
              placeholder="选择日期"
              style="width: 150px"
            ></DatePicker>
          </FormItem>
          <FormItem label="时间" prop="time" style="width: 150px">
            <TimePicker
              v-model="formItem.time"
              format="HH:mm"
              @on-change="chooseTime"
              placeholder="选择时间"
              style="width: 150px"
            ></TimePicker>
          </FormItem>
        </div>
        <FormItem label="实验内容与需求" prop="content" style="width: 366px">
          <Input
            v-model="formItem.content"
            type="textarea"
            @input="saveContent"
            placeholder="填写实验内容与需求"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateTechService",
  computed: {
    ...mapState({
      customerList: (state) => state.customer.customers,
    }),
  },
  data() {
    return {
      customerLoading: false,
      drawerOpened: false,
      formItem: {
        customer: undefined,
        content: undefined,
        scheduleTime: undefined,
        date: undefined,
        time: undefined,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "名字为必填项", trigger: "submit" },
        ],
        date: [{ required: true, message: "日期为必填项", trigger: "submit" }],
        time: [{ required: true, message: "时间为必填项", trigger: "submit" }],
      },
    };
  },
  methods: {
    ...mapActions({
      createTechService: "technicalService/createTechServiceAction",
      getTechService: "technicalService/getTechnicalServiceAction",
      getCustomers: "customer/getCustomersAction",
    }),
    openDrawer() {
      this.$refs["formItem"].resetFields();
      this.drawerOpened = true;
    },
    async searchCustomer(query) {
      if (query !== "") {
        this.customerLoading = true;
        const api = {
          skip: 0,
          limit: 15,
        };
        await this.getCustomers({ ...api, name: query });
        this.customerLoading = false;
      }
    },
    chooseTime(time) {
      this.formItem.time = time;
    },
    chooseDate(date) {
      this.formItem.date = date;
    },
    saveContent(content) {
      if (content) {
        this.formItem.content = content;
      } else {
        delete this.formItem.content;
      }
    },
    handleSubmit(name) {
      this.formItem.scheduleTime =
        this.formItem.date + " " + this.formItem.time;
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (!this.formItem.content) {
              delete this.formItem.content;
            }
            await this.createTechService(this.formItem);
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
            await this.getTechService();
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.dateTime
  display flex
</style>